/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import MainLayout from '../Layouts/Mainlayout';
import {
  TextField,
  Autocomplete,
  FormControl,
  InputAdornment,
  IconButton,
  Grid,
} from '@mui/material';
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import { getAllCampaigns, getAllBulkCampaigns } from 'src/services/campaignService';
import { getAlltemplate } from 'src/services/templateService';
import { getAlllisttrigger } from 'src/services/triggerService';
import type { RootState, TriggerResponse } from '../types/types';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ArrowDown01Icon, Download04Icon, Cancel01Icon } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { getAlltestemailsendhistory } from 'src/services/reportService';
import CsvService from 'src/services/dataExport.service';
//@ts-ignore
import { NotificationManager } from 'react-notifications';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import type { TableColumn } from 'react-data-table-component';
import { useSelector } from 'react-redux';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
//@ts-ignore
import { Clock01Icon } from '@hugeicons-pro/core-stroke-standard';
import MUIModal from '../MUIModal/MUIModal';
import TestEmailReason from './TestEmailReason';
interface TestEmailsendReportData {
  id: number;
  fromAddress: string;
  toAddresses: string;
  source: string;
  subject: string;
  templateName: string;
  campaignName: string;
  createdByName: string;
  createdOn: string;
  status: string;
  eventHistory : string;
}

const TestEmailsendReport: React.FC = (): JSX.Element => {
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const dateRangeRef: any = useRef(null);
  const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false);
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [reportDateRange, setReportDateRange] = useState<any>(null);
  const [reportData, setReportData] = useState<any[]>([]);
  const [selectedCampaignId, setSelectedCampaignId] = useState<number>(0);
  const { user } = useSelector((state: RootState) => state.auth);
  const [isCampaignLoading, setIsCampaignLoading] = useState<boolean>(false);
  const [campaignType, setCampaignType] = useState<string>('');
  const [clientId, setClientId] = useState<number>(0);
  const { setValue } = useForm();
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const [testEmailInfoData, setTestEmailInfoData] = useState<any>();
  const [openTestEmailModal, setOpenTestEmailModal] = useState(false);
  
  
  

  const fetchReportData = async (campaignId: number, startDate?: string, endDate?: string): Promise<void> => {
    const ClientId = user?.clientId ?? 0;
    setIsDataLoading(true);
    try {
      const res = await getAlltestemailsendhistory(ClientId, campaignType, campaignId, startDate ?? '', endDate ?? '');
      if (res.status === 200 && res.data.result === 1) {
        const reportData = res.data.data;
        if (reportData.length > 0) {
          setReportData(reportData);
        } else {
          setReportData([]);
          NotificationManager.error('No data available', '', 5000);
        }
      } else {
        setReportData([]);
        NotificationManager.error('No data available', '', 5000);
      }
    } catch (error) {
      console.log("Error fetching report data: ", error);
      setReportData([]);
    } finally {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    if (!user?.clientId) return;
    const ClientId = user.clientId;
    setClientId(ClientId);
    setIsDataLoading(true);
    getAllCampaigns(ClientId)
      .then((res: TriggerResponse) => {
        if (res.status === 200 && res.data.result === 1) {
          setCampaigns(res.data.data);
        } else {
          setCampaigns([]);
        }
      })
      .catch((error: any) => console.log("Error: ", error))
      .finally(() => setIsDataLoading(false));
  }, [user]);

  // useEffect(() => {
  //   if (!user?.clientId) return;
  //   const formattedStartDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
  //   const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : '';
  //   void fetchReportData(selectedCampaignId, formattedStartDate, formattedEndDate);
  // }, [selectedCampaignId, fromDate, endDate, user?.clientId]);

  const handleClearDateRange = (): void => {
    setFromDate(null);
    setEndDate(null);
    setReportDateRange(null);
  };

  const handleExportReport = (): void => {
       setIsDataLoading(true);
    const data: any[] = [];
    if (reportData.length > 0) {
      reportData.forEach((item: any) => {
        data.push({
          "From address": item.fromAddress,
          "To address": item.toAddresses,
          "Source": item.source,
          "Subject":item.subject ,
          "Template name":item.templateName,
          "Campaign name":item.campaignName,
          "Created by": item.createdByName,
          "Created on": moment(item.createdOn).format("MM-DD-YYYY HH:mm:ss"),
          "Status": item.status,
          "Reason": item.eventHistory,
        });
      });
      const csvData = CsvService.jsonToCsv(data);
         setIsDataLoading(false);
      CsvService.downloadCsvFile(csvData, 'Test_Email_Send_Reports.csv');
    } else {
      setIsDataLoading(false);
      NotificationManager.error('No data available for download', '', 5000);
    }
  };

  const handleDateRangeClick = (ranges: any): void => {
    const selectedStart = ranges.selection.startDate;
    const selectedEnd = ranges.selection.endDate;
    setReportDateRange({ startDate: selectedStart, endDate: selectedEnd, key: 'selection' });
    if (selectedStart !== selectedEnd) {
      setFromDate(selectedStart);
      setEndDate(selectedEnd);
      setTimeout(() => setIsDateRangeOpen(false), 500);
    }
  };

  const handleDateChange = (): void => {
    setIsDateRangeOpen(true);
    const defaultDate = new Date();
    setReportDateRange({ startDate: fromDate ?? defaultDate, endDate: endDate ?? defaultDate, key: 'selection' });
  };

  const getDateRangeDisplayValue = (): string => {
    if (fromDate && endDate) {
      return `${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}`;
    }
    return '';
  };

  const handleCampaignChange = (selectedCampaign: any): void => {   
    const id = selectedCampaign?.campaignId ?? 0;
    setSelectedCampaignId(id);
  };

  const handleViewReason = (row: TestEmailsendReportData): void => {
    setTestEmailInfoData({ id: row.id, eventHistory: row.eventHistory });
    setOpenTestEmailModal(true);
  };

  const options = [    
      { value: 'triggeremail', label: 'Trigger Email' },
      { value: 'bulkemail', label: 'Bulk Email' },
      { value: 'template', label: 'Template' },
      { value: 'listtrigger', label: 'ListTrigger' }
    ];
  
    const handleCampaignList = (newValue: any): void => {
  setIsCampaignLoading(true);

  if (newValue) {
    const selectedType = newValue.value;
    setCampaignType(selectedType);
    setValue('campaignId', 0);
    setCampaigns([]);

    const loadCampaigns = async (): Promise<void> => {
      try {
        let response: any;
        let normalizedCampaigns: any[] = [];

        if (selectedType === 'triggeremail') {
          response = await getAllCampaigns(clientId);
          if (response.status === 200 && response.data.result === 1) {
            normalizedCampaigns = response.data.data.map((campaign: any) => ({
              campaignId: campaign.campaignId,
              name: campaign.name,
              brandName: campaign.brandName,
              sent: campaign.sent,
              open: campaign.open,
              clicks: campaign.clicks,
            }));
          }
        } else if (selectedType === 'bulkemail') {
          response = await getAllBulkCampaigns(clientId);
          if (response.status === 200 && response.data.result === 1) {
            normalizedCampaigns = response.data.data.map((campaign: any) => ({
              campaignId: campaign.bulkCampaignId,
              name: campaign.bulkCampaignName,
              templateName: campaign.templateName,
              sent: campaign.sent,
              open: campaign.open,
              clicks: campaign.clicks,
            }));
          }
        } else if (selectedType === 'template') {
          response = await getAlltemplate(clientId);
          if (response.status === 200 && response.data.result === 1) {
            normalizedCampaigns = response.data.data.map((template: any) => ({
              campaignId: template.id,
              name: template.templateName,
              createdBy: template.createdByName,
              createdOn: template.createdOn,
            }));
          }
        } else if (selectedType === 'listtrigger') {
          response = await getAlllisttrigger(clientId);
          if (response.status === 200 && response.data.result === 1 && Array.isArray(response.data.data)) {
            const normalizedCampaigns = response.data.data.map((campaign: any) => ({
              campaignId: campaign.listTriggerId ?? campaign.campaignId, // use whichever ID your API returns
              name: campaign.name || campaign.listTriggerName || 'Unnamed ListTrigger',
              brandName: campaign.brandName ?? '',
            }));
            setCampaigns(normalizedCampaigns);
          } else {
            setCampaigns([]);
          }
        }

        setCampaigns(normalizedCampaigns);
      } catch (error) {
        console.error('Error fetching campaign data:', error);
        setCampaigns([]);
      } finally {
        setIsCampaignLoading(false);
      }
    };

    void loadCampaigns();
  } else {
    // Reset everything if no selection
    setIsDataLoading(false);
    setIsCampaignLoading(false);
    setCampaignType('');
    setCampaigns([]);
    setValue('campaignId', 0);
  }
};


  const columns: TableColumn<TestEmailsendReportData>[] = [
    { 
      name: 'From Address', 
      selector: row => row.fromAddress, 
      width: '13%', 
      wrap: true,
      sortable: true,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
              <CustomTooltip title={row.fromAddress} placement="bottom" arrow={false}>
                <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.fromAddress}</p>
              </CustomTooltip>
            </div>
            
          </div>
        )
    }},
    { 
      name: 'To Address', 
      selector: row => row.toAddresses, 
      width: '13%', 
      wrap: true,
      sortable: true,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
              <CustomTooltip title={row.toAddresses} placement="bottom" arrow={false}>
                <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.toAddresses}</p>
              </CustomTooltip>
            </div>
            
          </div>
        )
    }},
    { 
      name: 'Source', 
      selector: row => row.source, 
      width: '11%', 
      wrap: true,
      sortable: true,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
              <CustomTooltip title={row.source} placement="bottom" arrow={false}>
                <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.source}</p>
              </CustomTooltip>
            </div>
            
          </div>
        )
    }},
    { 
      name: 'Subject', 
      selector: row => row.subject, 
      width: '13%', 
      wrap: true,
      sortable: true,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
              <CustomTooltip title={row.subject} placement="bottom" arrow={false}>
                <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.subject}</p>
              </CustomTooltip>
            </div>
            
          </div>
        )
    }},
    { 
      name: 'Campaign Name', 
      selector: row => row.campaignName, 
      width: '13%', 
      wrap: true,
      sortable: true,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
              <CustomTooltip title={row.campaignName} placement="bottom" arrow={false}>
                <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.campaignName}</p>
              </CustomTooltip>
            </div>
            
          </div>
        )
    }},
    { 
      name: 'Created By', 
      selector: row => row.createdByName, 
      width: '13%',
      cell: (row: any) => {
      return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
              <div className="overflow-hidden" style={{ width: '100%' }}>
                  {row?.createdByName && (
                      <p className="text-14 text-muted"><span className='font-semibold'>User: </span>{row.createdByName}</p>
                  )}
                  {row?.createdOn && (
                      <div title={moment(row.createdOn).format("MM/DD/YYYY")}><span className='font-semibold'>Date: </span>{moment(row.createdOn).format("MM/DD/YYYY")}</div>
                  )}
              </div>
          </div>
        )
    },},
    { 
      name: 'Status', 
      selector: row => row.status, 
      width: '11%', 
      wrap: true,
      sortable: true,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            
            <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted" style={{ width: '100%' }}>
              <CustomTooltip title={`TestEmailLogId : ${String(row.id)}`} placement="bottom" arrow={false}>
                <p className='overflow-hidden text-ellipsis whitespace-nowrap w-full'>{row.status}</p>
              </CustomTooltip>
            </div>
            
          </div>
        )
    }},
    {
      name: 'Actions',
      cell: (row: TestEmailsendReportData) => (
        <div className="flex justify-center items-center w-full">
          {
            (row.status.toLowerCase() === 'failed' || row.status.toLowerCase() === 'email sent') && (
              <HugeiconsIcon
                icon={Clock01Icon}
                size={20}
                color="#3A3A3A"
                strokeWidth={0.2}
                onClick={() => handleViewReason(row)}
              />
            )
          }
        </div>
      ),
      center: true,
      sortable: false,
    } 
  ]

  return (
  <div className="flex flex-row justify-start">
    <MainLayout>
      <>
        <h2 className="text-2xl font-semibold text-title">Test Email Send Reports</h2>

        {/* Filter Form */}
        <div className="mt-[20px] mb-[20px] live-outreach-container">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formattedStartDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
              const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : '';
              void fetchReportData(selectedCampaignId, formattedStartDate, formattedEndDate);
            }}
            className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-5"
          >
            {/* Campaign Type */}
            <div className="w-full lg:w-auto">
              <FormControl fullWidth>
                <Autocomplete
                  options={options}
                  getOptionLabel={(option) => option.label}
                  popupIcon={
                    <HugeiconsIcon
                      icon={ArrowDown01Icon}
                      size={18}
                      color="#3A3A3A"
                      strokeWidth={0.2}
                    />
                  }
                  onChange={(event, newValue) => handleCampaignList(newValue)}
                  value={options.find((opt) => opt.value === campaignType) ?? null}
                  renderInput={(params) => (
                    <TextField
                      label="Test Email Type"
                      {...params}
                      placeholder="Select Test Email Type"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '40px',
                          height: '40px',
                          width: '205px',
                        },
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-clearIndicator': {
                      marginRight: '-12px',
                    },
                    '& .MuiAutocomplete-input': {
                      width: '70%',
                    },
                  }}
                />
              </FormControl>
            </div>

            {/* Campaign */}
            <div className="w-full lg:w-auto">
              <FormControl fullWidth>
                <Autocomplete
                  options={campaigns}
                  disabled={campaignType === '' || isCampaignLoading}
                  loading={isCampaignLoading}
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                  getOptionLabel={(option: any) => option?.name || ''}
                  popupIcon={
                    isCampaignLoading ? (
                      <span className="loading loading-spinner loading-sm text-gray-400"></span>
                    ) : (
                      <HugeiconsIcon
                        icon={ArrowDown01Icon}
                        size={18}
                        color="#3A3A3A"
                        strokeWidth={0.5}
                      />
                    )
                  }
                  // ✅ Ensure value is null when none selected
                  value={
                    selectedCampaignId
                      ? campaigns.find((c) => c.campaignId === selectedCampaignId) || null
                      : null
                  }
                  onChange={(_, selectedCampaign) => handleCampaignChange(selectedCampaign)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Source"
                      placeholder="Select Source"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '40px',
                          height: '40px',
                          width: '250px',
                        },
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-clearIndicator': { marginRight: '-12px' },
                    '& .MuiAutocomplete-input': { width: '70%' },
                  }}
                />

              </FormControl>
            </div>

            {/* Date Range */}
            <div className="w-full lg:w-auto">
              <FormControl>
                <TextField
                  id="date-range"
                  label="Date Range"
                  variant="outlined"
                  autoComplete="off"
                  ref={dateRangeRef}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                        {getDateRangeDisplayValue() && (
                          <IconButton
                            onClick={handleClearDateRange}
                            size="small"
                            sx={{ marginRight: '4px' }}
                          >
                            <HugeiconsIcon
                              icon={Cancel01Icon}
                              size={16}
                              color="#666"
                              strokeWidth={0.5}
                            />
                          </IconButton>
                        )}
                        <HugeiconsIcon
                          icon={Calendar03Icon}
                          size={18}
                          color="#3A3A3A"
                          strokeWidth={0.5}
                          onClick={handleDateChange}
                        />
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleDateChange}
                  onFocus={handleDateChange}
                  value={getDateRangeDisplayValue()}
                  placeholder="Select date range"
                  sx={{
                    width: { xs: '100%', sm: '225px', md: '225px', lg: '225px' },
                    minWidth: '270px',
                    '& .MuiOutlinedInput-root': {
                      height: '56px',
                      '& .MuiOutlinedInput-input': {
                        padding: '16px 14px',
                        height: 'auto',
                        lineHeight: '1.4375em',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      padding: '0 4px',
                      fontSize: '13px',
                      lineHeight: '1.2',
                    },
                  }}
                />
                {isDateRangeOpen && (
                  <div
                    ref={dateRangeRef}
                    style={{
                      position: 'absolute',
                      zIndex: '999',
                      top: '100%',
                      marginTop: '4px',
                    }}
                  >
                    <DateRangePicker
                      ranges={reportDateRange ? [reportDateRange] : []}
                      onChange={handleDateRangeClick}
                      dateDisplayFormat={'MM/dd/yyyy'}
                      inputRanges={[]}
                      color={'#FFF5F6'}
                      rangeColors={['#D6242C']}
                      editableDateInputs={true}
                      startDatePlaceholder={'MM/DD/YYYY'}
                      endDatePlaceholder={'MM/DD/YYYY'}
                    />
                  </div>
                )}
              </FormControl>
            </div>

            {/* Buttons Section */}
            <div className="flex flex-wrap gap-2 sm:gap-3 lg:gap-2 w-full lg:mt-2">
              {/* Reset Button */}
              <div className="w-full sm:w-auto">
                <OutlineButton
                  color="gray"
                  onClick={() => {
                    // Clear campaign type and related data
                    setCampaignType('');
                    setCampaigns([]);

                    // Reset selected campaign
                    setSelectedCampaignId(0);

                    // Clear date range
                    handleClearDateRange();

                    // Clear table data
                    setReportData([]);

                    // Also close the date picker if open
                    setIsDateRangeOpen(false);
                  }}
                  disabled={isDataLoading}
                  width="120px"
                >
                  Reset
                </OutlineButton>
              </div>

              {/* Submit Button */}
              <div className="w-full sm:w-auto">
                <GradientButton
                    type="submit"
                    color="red"
                    disabled={isDataLoading}
                    width="120px"
                    onClick={() => {
                      const formattedStartDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
                      const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : '';
                      void fetchReportData(selectedCampaignId, formattedStartDate, formattedEndDate);
                    }}
                  >
                    {!isDataLoading ? 'Submit' : (
                      <span className="loading loading-spinner loading-xs text-white"></span>
                    )}
                </GradientButton>

              </div>

              {/* Download Button — show only if there’s data */}
              {reportData.length > 0 && (
                <div className="w-full sm:w-auto">
                  <OutlineButton
                    onClick={handleExportReport}
                    type="rounded"
                    color="gray"
                    width="120px"
                    disabled={isDataLoading}
                  >
                    <HugeiconsIcon
                      icon={Download04Icon}
                      size={20}
                      color="#3a3a3a"
                      stroke="0.2"
                    />
                    <span className="ml-[5px]">Download</span>
                  </OutlineButton>
                </div>
              )}
            </div>

          </form>
        </div>

        {/* Data Table */}
        <div className="data-table-container te-table-container mb-10">
          <CustomDataTable
            columns={columns}
            data={reportData}
            pagination
            responsive
            progressPending={isDataLoading}
            customStyles={{
              rows: {
                style: {
                  cursor: 'pointer',
                },
              },
            }}
          />
        </div>
        <MUIModal title={`Event Details : #${String(testEmailInfoData?.id ?? '')}`} openModal={openTestEmailModal} closeModal={() => setOpenTestEmailModal(false)} width={'50%'} >
                  <TestEmailReason reason ={testEmailInfoData?.eventHistory} />
        </MUIModal>
      </>
    </MainLayout>
  </div>
  );


};

export default TestEmailsendReport;
